import React from "react";
import HeroCTR from "../../components/hero/HeroSectionComp";
import InfoCTR from "../../containers/home/InfoCTR"
import ContactUsCTR from "../services/ContactusCTR";
import { Link } from "react-router-dom";

function ServiceCTR() {
  return (
    <div>
      <HeroCTR
        img="/images/hero/bg-subheader.jpg"
        heading="Services"
        para="Travel Made Effortless"
      />

      <div className="mt-12 md:mt-22">
        {/* Section 1 */}
        <div className="flex flex-col md:flex-row gap-4 md:gap-22 items-center justify-between">
          <div
            className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
            style={{ backgroundImage: "url('/images/services/s1.jpg')" }}
          ></div>
          <div className="flex-1">
            <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
              A Perfect Place Vacation
            </h3>
            <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
              Experience vacations crafted to perfection. At Bonvoy Tourism, we design every journey to inspire and delight, whether you’re seeking serene beaches, bustling cities, or hidden cultural treasures. Every trip is tailored to ensure comfort, adventure, and unforgettable memories.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px]">
              Our dedicated team of travel experts takes care of every detail—from selecting the finest accommodations to curating immersive local experiences—so you can focus on exploring, relaxing, and making memories that last a lifetime. With Bonvoy Tourism, your vacation becomes a seamless story of discovery and joy.
            </p>
          </div>
        </div>

        <div className="mb-[48px]">
          <InfoCTR />
        </div>

        {/* Section 2 */}
        <div className="flex flex-col-reverse md:flex-row gap-4 md:gap-22 items-center justify-between mt-4 md:mt-0">
          <div className="flex-1">
            <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
              We have been in the tourism industry for more than 20 years
            </h3>
            <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
              Leave your guidebooks at home and dive into the local cultures that make each destination so special. We’ll connect you with our exclusive experiences.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px]">
              Every journey is carefully designed to immerse you in the destination’s unique culture, sights, and flavors, making your experience authentic and unforgettable.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px]">
              Our team handles all the details, from accommodations to activities, so you can relax and fully enjoy every moment of your adventure.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px] mb-5">
              With Bonvoy Tourism, each trip becomes more than a vacation—it’s a seamless blend of discovery, comfort, and lifelong memories.
            </p>
            <Link
              to="/contactus"
              className="bg-[#ff9219] text-white mt-[8px] py-2 px-3 rounded-[4px] font-medium hover:bg-slate-400 transition-all duration-300 ease-in-out"
            >
              Book Now
            </Link>
          </div>
          <div
            className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
            style={{ backgroundImage: "url('/images/services/s2.jpg')" }}
          ></div>
        </div>

        <ContactUsCTR />
      </div>

    </div>
  );
}

export default ServiceCTR;
